/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const apiConfig = {
  gql: {
    url: 'https://staging-api-parametro.klefki.io/core/v1/graphql/',
  },
  rest: {
    url: 'https://staging-api-parametro.klefki.io/iam/v1',
  },
  sendOTPEP: '/user/sign-up',
  SignInUserEP: '/user/sign-in',
  accessTokenEP: '/user/access-token/get',
};
